import { Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import BannerCarousel from "../BannerCarousel/BannerCarousel";
import DealPagination from "../ViewMore/DealPagination";
import BlogCarousel from "../BlogCarousel/BlogCarousel";
import { useLocation } from "react-router-dom";
import { serviceFetchUserDetails } from "../../api/service/services";
import { AxiosError, AxiosResponse } from "axios";
import BankOffersCarousel from "../BankOffersCarousel/BankOffersCarousel";
import TodaysDealBanner from "../TodayDeal/TodayDeals";
import SeasonalSale from "../SeasonalSale/SeasonalSale";
import ProductDealsCarousel from "../ProductDealCarousel/ProductDealCarousel";

const HomePage = () => {
  const location = useLocation();

  const urlParams =
    new URLSearchParams(window.location.search) || location.search;
  const status = urlParams.get("status") || "";
  const email = urlParams.get("email") || "";
  const token = urlParams.get("token") || "";
  const name = urlParams.get("name") || "";

  useEffect(() => {
    if (status === "success") {
      if (token !== "" && email !== "" && name !== "") {
        localStorage.setItem("token", token);
        localStorage.setItem("email", email);
        localStorage.setItem("displayName", name);
        serviceFetchUserDetails(email)
          .then((response: AxiosResponse) => {
            localStorage.setItem("userId", response?.data?.user_uuid);
          })
          .catch((error: AxiosError<any>) => {
            console.log("Error:", error.response?.data);
          });
      }
      window.location.href = "/";
    }
  }, [email, name, status, token]);

  useEffect(() => {
    if (location.hash) {
      const hash = decodeURIComponent(location.hash);
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // adjust if needed
    }
  }, [location]);

  return (
    <div>
      <Grid
        container
        gap={3}
        display="flex"
        flexDirection="column"
        justifyContent={"center"}
        alignContent={"center"}
        paddingTop={1}
      >
        <Grid item xs={12} md={12} lg={12}>
          <BannerCarousel />
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <ProductDealsCarousel />
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <SeasonalSale />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          bgcolor="#FCFCFC"
          borderRadius={"14px"}
          spacing={2}
          boxShadow={` 0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset`}
        >
          <DealPagination />
        </Grid>
        <Grid
          item
          xs={12}
          bgcolor="#FCFCFC"
          borderRadius={"14px"}
          spacing={2}
          boxShadow={` 0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset`}
        >
          <Grid item xs={12}>
            <Typography
              id="bank-offers-section"
              align="left"
              className="title-styles"
            >
              Bank offers only for you
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <BankOffersCarousel /* offers={bankOffers} */ />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          bgcolor="#FCFCFC"
          borderRadius={"14px"}
          spacing={2}
          boxShadow={` 0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset`}
        >
          <Grid item xs={12}>
            <Typography
              id="todays's-section"
              align="left"
              className="title-styles"
            >
              Today's Deals
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <TodaysDealBanner />
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          bgcolor="#FCFCFC"
          borderRadius={"14px"}
          spacing={2}
          boxShadow={` 0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset`}
        >
          <Grid item xs={12}>
            <Typography
              id="blogs-section"
              align="left"
              className="title-styles"
            >
              Blogs
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} lg={12} spacing={2}>
            <BlogCarousel />
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </div>
  );
};

export default HomePage;
